import { EmailNode } from '@react-email/editor/core';

export const SubjectDocument = EmailNode.create({
	name: 'doc',
	topNode: true,
	content: 'inline*',

	renderToReactEmail({ children }) {
		return children;
	},
});
